import { memo, PropsWithChildren } from 'react';

import { merge } from '@/components';
import { Flex } from '@/components/core';
import { DivProps } from '@/utils';

const ISettingsHeader = ({ className, children, ...rest }: PropsWithChildren<DivProps>) => {
  return (
    <Flex col className={merge('gap-md', className)} {...rest}>
      <Flex className="items-start">{children}</Flex>
    </Flex>
  );
};

export const SettingsHeader = memo(ISettingsHeader);
